import type { PlacementType } from 'react-laag/dist/PlacementType';
import type { UseHoverOptions, UseLayerOptions } from 'react-laag';

export type Placement = {
  placement: PlacementType;
  auto: boolean; //autoAdjust
  snap: boolean; //snapToAnchor
  triggerOffset: number; //triggerOffset
  containerOffset: number; //scrollOffset
  overflowContainer: boolean; // formerly fixed --> default changed
  possiblePlacements: Array<PlacementType>;
};
/**
 * The default {@link Placement} configuration for a react-laag/ToggleLayer.
 */
export const DEFAULT_PLACEMENT_CONFIG: Placement = {
  placement: 'bottom-start',
  auto: true,
  snap: true,
  triggerOffset: 12,
  containerOffset: 16,
  overflowContainer: false,
  possiblePlacements: [
    'top-start',
    'top-center',
    'top-end',
    'bottom-start',
    'bottom-center',
    'bottom-end',
    'left-start',
    'left-center',
    'left-end',
    'right-start',
    'right-center',
    'right-end'
  ]
};

export const DEFAULT_HOVER_CONFIG: UseHoverOptions = {
  delayEnter: 500,
  delayLeave: 100
};

export interface DefaultTooltipOptions {
  /**
   * Custom options to pass to {@link useTooltipDefault}. This should only be needed in very rare scenarios.
   */
  tooltipOptions?: Partial<UseHoverOptions> &
    Partial<UseLayerOptions> & { fixed?: boolean };
}
